<template>
    <div class="echart" :id="id"></div>
</template>
<script>
export default {
    name:'lineChart',
    data(){
         return {
             chart:''
         }
    },
    props: {
        id:{
            type:String
        },
        dataArray: { 
            type: Array | Object
        }
        // colorArr:{
        //     type: Array | Object,
        //     default: function () {
        //         let colr = 
        //         return colr;
        //     }
        // }
    },
    mounted() {
        const that = this
        that.$nextTick(()=> {
            that.init();
        })
    },
    watch: {
        'dataArray': function (n, o) {
            this.init();
        }
    },
    methods: {
        barOption(){
            let that = this;
            var xWidth = (that.xAxisName=='')?'10':'50';
            console.log(that.dataArray);
            that.dataArray.nodes.forEach((node,index) =>{
                that.dataArray.links.forEach((ele,i) =>{
                    if(that.dataArray.nodes[ele.target].labels == node.labels){
                        ele.posttime = node.posttime;
                    }
                });
            });
            that.dataArray.nodes[0].label = {
                 show: true,
                 formatter: function(param){
                    var newParams = param.data.labels;
                    if(param.data.posttime!=undefined){
                        newParams = param.data.labels + "\n" + param.data.posttime;
                    }
                    return newParams
                }
             }
            var option = {
                legend: {
                    textStyle:{
                       color:'#fff' 
                    },
                },
                // toolbox: {
                //     feature: {
                //         saveAsImage: {
                //             title: '下载',
                //         }
                //     }
                // },
                tooltip: {
                    formatter: function(param){
                        if(param.value == undefined){
                            return
                        }
                        return that.getParams(param);
                    }
                },
                color:["#ed7382","#94e8ab","#ffbf91","#94bafb","#f9fb94"],
                series: [{
                    type: 'graph',
                    // zoom:.5,
                    layout: 'force',
                    animation: true,
                    roam: true,
                    //focusNodeAdjacency: true,
                    label: {
                        //show: true,
                        position: 'right',
                        formatter: function(param){
                            var newParams = param.data.labels;
                            if(param.data.posttime!=undefined){
                                newParams = param.data.labels + "\n" + param.data.posttime
                            }
                            return newParams;
                        }
                    },
                    
                    draggable: true,
                    data: that.dataArray.nodes.map(function (node, idx) {
                        node.id = idx;
                        return node;
                    }),
                    categories: that.dataArray.categories,
                    force: {
                        // initLayout: 'circular'
                        // repulsion: 20,
                        edgeLength: 15,
                        repulsion: 30,
                        gravity: 0.2,
                        // layoutAnimation: false
                    },
                    edges: that.dataArray.links,
                    animationDuration: function (idx) {
                        // 越往后的数据时长越大
                        return idx * 1;
                    }
                }]
            };
            return option;
        },
        getParams(param,type){
            let that = this,num = 0;
            let newParams = "<div class='echartTip'><p>关系总览</p><table class='table'><tbody><tr><th>账号名</th><th>时间</th><th>来源</th></tr>"
            that.dataArray.links.forEach((ele,i) =>{
                if(that.dataArray.nodes[ele.source].labels == param.data.labels){
                    if(ele.posttime == undefined){
                        ele.posttime = ''
                    }
                    newParams += "<tr><td>"+that.dataArray.nodes[ele.target].labels+"</td><td>"+ele.posttime+"</td><td>"+param.data.labels+"</td></tr>";
                    num++;
                }
            });
            if(num == 0){
                newParams = param.data.labels + "<br/>" + param.data.posttime
            }
            newParams += "</tbody></table>"
            if(type == 1 && num == 0){
                return ''
            }
            return newParams;
        },
        init(){
            let that = this;
            that.$echarts.init(document.getElementById(that.id)).dispose();
            that.chart = that.$echarts.init(document.getElementById(that.id));
            that.chart.setOption(that.barOption());
            window.addEventListener("resize",function(){
                that.chart.resize(); 
            });
            $("#"+that.id).append("<div class='toolTip'></div>");
            that.chart.getZr().on('click', param => {
                $(".toolTip").empty().hide()
            });
            that.chart.on('click',function(param){
                //console.log(param.event)
                var arrayIndex = param.dataIndex;
                if (param.dataType == 'node') {
                    let html = that.getParams(param,1);
                    if(html == ''){
                        $(".toolTip").empty().hide()
                        return
                    }
                    $(".toolTip").show().empty().append(html);
                    let curX = param.event.offsetX;
                    let curY = param.event.offsetY;
                    let wx = $("#"+that.id).width();
                    let wy = $("#"+that.id).height();
                    let tipW = $(".toolTip").width();
                    let tipH = $(".toolTip").height();
                    if((curX+tipW) > (wx-20)){
                        curX = param.event.offsetX - tipW - 40
                    }else{
                        curX = param.event.offsetX + 20;
                    }
                    if((curY+tipH) > (wy-20)){
                        curY = param.event.offsetY - tipH - 40
                    }else{
                        curY = param.event.offsetY + 20;
                    }
                    $(".toolTip").css({"left":curX,"top":curY})
                }else{
                    $(".toolTip").empty().hide()
                }
            });
            that.chart.on('mouseup',function(params){
                var option=that.chart.getOption();
                //console.log(option.series[0].data[params.dataIndex]);
                option.series[0].data[params.dataIndex].x=params.event.offsetX;
                option.series[0].data[params.dataIndex].y=params.event.offsetY;
                option.series[0].data[params.dataIndex].fixed=true;
                that.chart.setOption(option);
            });
        },
    },
}
</script>
<style lang="" scoped>
    .echart{width:100%;height:100%}
</style>


// WEBPACK FOOTER //
// src/components/echart/pathChart1.vue